import React from "react";

export default function ButtonSubmit() {
  return (
    <>
      <button className="mt-3 h-10 rounded-md border-solid border-black bg-green-600 hover:bg-green-700 px-2 text-center font-bold text-white">
        Kirim
      </button>
    </>
  );
}
